import {
    IMarketingEventsDepartmentsDTO,
    IMarketingEventsDepartmentsViewDTO,
    IMarketingEventsDistributorsDTO,
    IMarketingEventsDistributorsViewDTO,
    IMarketingEventsDTO,
    IMarketingEventsFactDepartmentsDTO,
    IMarketingEventsFactDepartmentsViewDTO,
    IMarketingEventsPlanDepartmentsDTO,
    IMarketingEventsPlanDepartmentsViewDTO,
    IMarketingEventsProductsDTO,
    IMarketingEventsProductsViewDTO,
    IMarketingEventsViewDTO
} from "../../libs/coreapi-dto/dirs/marketingEvents";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";

export class MarketingEventsDataProvider extends DictionaryDataProvider<IMarketingEventsViewDTO, IMarketingEventsDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<IMarketingEventsViewDTO, IMarketingEventsDTO>> {
        return this._coreApiService.marketingEventsRequest
    }

    getViewParam(filter: IViewBody, callback?: (data: IMarketingEventsViewDTO[], totalCount: number,) => void, report?: (value) => void) {
        this._coreApiService.marketingEventsRequest
            .then(r => r
                .getViewParam(filter, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e.data.entities, e.data.totalCount);
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.detail ?? 'DictionaryDataProvider getView !isCompleted');
                }, (value) => { report?.(value) })
            )
            .catch((e) => {
                throw new Error(e?.message.text ?? 'getView DictionaryDataProvider')
            });
    }
}

//Товары маркетинговых мероприятий
export class MarketingEventsProductsDataProvider extends DictionaryDataProvider<IMarketingEventsProductsViewDTO, IMarketingEventsProductsDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<IMarketingEventsProductsViewDTO, IMarketingEventsProductsDTO>> {
        return this._coreApiService.marketingEventsProductsRequest
    }
}

//Планы по участникам маркетинговых мероприятий
export class MarketingEventsPlanDepartmentsDataProvider extends DictionaryDataProvider<IMarketingEventsPlanDepartmentsViewDTO, IMarketingEventsPlanDepartmentsDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<IMarketingEventsPlanDepartmentsViewDTO, IMarketingEventsPlanDepartmentsDTO>> {
        return this._coreApiService.marketingEventsPlanDepartmentsRequest
    }
}

//Планы по участникам маркетинговых мероприятий
export class MarketingEventsFactDepartmentsDataProvider extends DictionaryDataProvider<IMarketingEventsFactDepartmentsViewDTO, IMarketingEventsFactDepartmentsDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<IMarketingEventsFactDepartmentsViewDTO, IMarketingEventsFactDepartmentsDTO>> {
        return this._coreApiService.marketingEventsFactDepartmentsRequest
    }
}

//Дистрибьюторы маркетинговых мероприятий
export class MarketingEventsDistributorsDataProvider extends DictionaryDataProvider<IMarketingEventsDistributorsViewDTO, IMarketingEventsDistributorsDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<IMarketingEventsDistributorsViewDTO, IMarketingEventsDistributorsDTO>> {
        return this._coreApiService.marketingEventsDistributorsRequest
    }
}

//Департаменты маркетинговых мероприятий
export class MarketingEventsDepartmentsDataProvider extends DictionaryDataProvider<IMarketingEventsDepartmentsViewDTO, IMarketingEventsDepartmentsDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<IMarketingEventsDepartmentsViewDTO, IMarketingEventsDepartmentsDTO>> {
        return this._coreApiService.marketingEventsDepartmentsRequest
    }
}